import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconLan24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="network">
            <path
                d="M7 11V18H5V11H7Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11 18V11H9V18H11Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M15 11V18H13V11H15Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M19 18V11H17V18H19Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2C8 1.44772 8.44772 1 9 1H15C15.5523 1 16 1.44772 16 2V4H19C19.5523 4 20 4.44772 20 5V7H23C23.5523 7 24 7.44772 24 8V21C24 21.5523 23.5523 22 23 22H1C0.447715 22 0 21.5523 0 21V8C0 7.44772 0.447715 7 1 7H4V5C4 4.44772 4.44772 4 5 4H8V2ZM10 5C10 5.55228 9.55229 6 9 6H6V8C6 8.55228 5.55228 9 5 9H2V20H22V9H19C18.4477 9 18 8.55228 18 8V6H15C14.4477 6 14 5.55228 14 5V3H10V5Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
